<template>
<div class="ecs-tab">
    <TabItem v-for="item in items" :count="countRequest[item.key]" :key="item.key" :tabItemKey="item.key" :active="isActive(item.key)" @click="emitChange">{{ item.label }}</TabItem>
</div>
</template>
<script>
import TabItem from './TabItem.vue';
export default {
    name: "Tab",
    props: {
        items: {
            type: Array,
            default() {
                return [];
            }
        },
        active: {
            type: String
        },
        countRequest: {
            type: Object,
        }
    },
    components: {
        TabItem
    },
    methods: {
        isActive(key) {
            return this.active === key;
        },
        emitChange(key) {
            this.$emit('change', key);
        }
    }
}
</script>
<style type="scss" scoped>
.ecs-tab {
    display: inline-flex;
    background: #eeeeee;
    border-radius: 10px;
    padding: 2px;
    color: #303C54;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
}
</style>